/** @format */

import React from "react";
import Button from "../component/Button";
import { useAuth } from "../context/AuthContext";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { BsBell } from "react-icons/bs";
import { FaEllipsisV } from "react-icons/fa";

const Navbar = () => {
  const navigate = useNavigate();

  //onScroll Effect for the Navbar
  window.addEventListener("scroll", (e) => {
    let navbar = document.querySelector(".fixed__top");

    if (window.scrollY >= 10) {
      navbar.style.backgroundColor = "var(--light)";
      navbar.style.boxShadow = "0 2px 4px 1px var(--secondary)";
    } else if (window.scrollY <= 334) {
      navbar.style.backgroundColor = "transparent";
      navbar.style.boxShadow = "";
    }
  });

  const {
    handleShowSignupPopup,
    handleShowLoginPopup,
    handleShowAdminLoginPopup,
    logOutUser,
    currentUser,
    backButton,
  } = useAuth();

  return (
    <div className="fixed__top">
      <nav className="navbar">
        <div className="logo">CLOOB-SCHOOL</div>
        <div className="nav">
          {!currentUser && (
            <div onClick={handleShowLoginPopup} className="nav__link">
              login
            </div>
          )}
          {!currentUser && (
            <div onClick={handleShowSignupPopup} className="nav__link">
              Sign-up
            </div>
          )}

          {!currentUser && (
            <Button
              onClick={handleShowAdminLoginPopup}
              btnText="Admin"
              color="#f3f3f3"
              bg="var(--success)"
            />
          )}
          {currentUser && !backButton && (
            <BsBell className="bell__notification" />
          )}

          {currentUser && (
            <NavLink to="/" onClick={logOutUser} className="nav__link">
              Log-out
            </NavLink>
          )}

          {currentUser && backButton && (
            <Link to={-1} className="nav__link">
              Back
            </Link>
          )}

          {/* {currentUser && !backButton && <FaEllipsisV />} */}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
